<template>
  <Layout>
    <div class="py-16 mx-4">
      <Cenik></Cenik>
    </div>

    <div class="flex flex-col items-center mx-6">
      <div id="casyprijezdu" style="max-width: 36rem;" class="py-8">
        <h1 class="pb-4 text-4xl text-center text-chblue">Trvání pobytu</h1>
        <p class="text-sm text-chsoftblue">
          V hlavní sezoně (není-li individuální dohoda): nástup v
          <b>sobotu</b> mezi <b>12:00 - 13:00</b>.
        </p>
        <p class="text-sm text-chsoftblue">
          Pobyt končí následující <b>sobotu</b> v <b>10:00</b>.
        </p>
        <p class="text-sm text-chsoftblue">
          Mimo sezonu - dohoda. Zimní období - mimo provoz (dle počasí).
        </p>
      </div>
      <div id="platba" class="pt-8 pb-20" style="max-width: 36rem;">
        <h1 class="pb-4 text-4xl text-center text-chblue">
          Informace o platbě
        </h1>
        <p class="text-sm text-chsoftblue">
          Žádáme o zaslání nevratné zálohy ve výši <b>20 % z ceny</b> pobytu na
          bankovní účet uvedený v objednávce nebo poštovní poukázkou na adresu
          poskytovatele ve stanoveném termínu - tím bude potvrzena rezervace.
        </p>
        <p class="pt-4 text-sm text-chsoftblue">
          V den příjezdu bude zaplacen doplatek <b>80 % z ceny </b> pobytu,
          rekreační poplatek 40,-Kč za noc, neplatí děti do 18 let, poplatek za povolení k vjezdu
          automobilu k chatě 50,-Kč/pobyt.
        </p>
      </div>
    </div>
  </Layout>
</template>

<script>
import Cenik from "../components/Cenik.vue";
import Layout from "../Layouts/default.vue";
export default {
  components: {
    Cenik,
    Layout,
  },
};
</script>
